import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  riskManagementState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const riskManagementSlice = createSlice({
  name: 'riskManagement',
  initialState: initialState,
  reducers: {
    getRiskManagementRequest: (state: any) => {
      state.riskManagementState.isFetching = true
      state.riskManagementState.isFetched = false
      state.riskManagementState.isFailed = false
      state.riskManagementState.errorMessage = ''
    },
    getRiskManagementSuccess: (state: any, action) => {
      state.riskManagementState.isFetching = false
      state.riskManagementState.isFetched = true
      state.riskManagementState.item = action.payload.item
    },
    getRiskManagementFailure: (state: any, action) => {
      state.riskManagementState.isFetching = false
      state.riskManagementState.isFetched = true
      state.riskManagementState.isFailed = true
      state.riskManagementState.errorMessage = action.payload.errorMessage
    },
  },
})

export const {
  getRiskManagementRequest,
  getRiskManagementSuccess,
  getRiskManagementFailure,
} = riskManagementSlice.actions

export default riskManagementSlice.reducer
